/**
 * Enumeration of possible pin types
 *
 * @name PIN_TYPE
 * @enum {string}
 */
const PIN_TYPE = {
  STRING: 'string',
  NUMBER: 'number',
  BOOLEAN: 'boolean',
  PULSE: 'pulse',
  BYTE: 'byte',
  PORT: 'port',
  DEAD: 'dead',
  // generic types
  T1: 't1',
  T2: 't2',
  T3: 't3',
};

export default PIN_TYPE;
